import {
	Input,
	InputAutoCompleteGoogleMaps,
	Message,
	Typography
} from 'components'
import { ContentSetUpProps, TypographyTypes, locationState } from 'interfaces'
import { RegexEspecial } from 'lib'
import React, { Dispatch, SetStateAction } from 'react'
import { Controller } from 'react-hook-form'
import ReactQuill from 'react-quill'
import { configGenaral } from 'utils'

export const ContentSetUp: React.FC<ContentSetUpProps> = ({
	titleComponent = 'Content Set Up',
	setItem,
	item,
	watch,
	register,
	setValue,
	errors,
	control
}): JSX.Element => {
	const maxQuantity =
		titleComponent === 'Create New Location'
			? configGenaral.maxTitleLengthLocationName
			: configGenaral.maxTitleLength

	const rules = {
		title: {
			required: { value: true, message: 'This field is required' },
			maxLength: {
				value: maxQuantity,
				message: 'Maximum characters exceeded'
			},
			pattern: {
				value: RegexEspecial,
				message: 'Invalid Field'
			}
		},
		description: {
			required: { value: true, message: 'This field is required' },
			maxLength: {
				value: configGenaral.maxDescriptionLength,
				message: 'Maximum characters exceeded'
			},
			validate: (e: string) => {
				return e !== '<p><br></p>'
			}
		},
		template: {
			required: { value: false }
		}
	}

	const title = watch?.('title')

	return (
		<div className="w-full">
			<Typography
				title={titleComponent}
				className="text-gray-9 border-b border-gray-11 pb-3"
				type={TypographyTypes.h2}
				fontLeading="22/27"
			/>
			<div className="mt-5">
				<div className="flex gap-4">
					<Input
						name="title"
						title={
							titleComponent === 'Create New Location'
								? 'Location’s Name'
								: 'Title'
						}
						type="text"
						register={register}
						rules={rules.title}
						placeholder={
							titleComponent === 'Create New Location' ? 'Name' : 'Title'
						}
						error={errors.title}
						limit
						watchValue={title}
						setValueInput={setValue}
						cantLimit={maxQuantity}
						borderFull={false}
						inputClassName="!p-0 rounded"
						titleClassName="!text-[12px] !leading-[12px]"
					/>

					{/* <Input
						name="template"
						title="Template"
						type="text"
						rightIcon={Icons.search}
						register={register}
						rules={rules.template}
						error={errors.template}
						borderFull={false}
						placeholder="Template"
						inputClassName="!p-0 rounded"
						titleClassName="!text-[10px] !leading-[12px]"
					/> */}
				</div>
				{titleComponent === 'Create New Location' && (
					<div className="flex gap-4 flex-col w-full">
						<InputAutoCompleteGoogleMaps
							title
							location={item as locationState}
							setLocation={setItem as Dispatch<SetStateAction<locationState>>}
							classNameInput="p-2 w-[100%]"
						/>
					</div>
				)}

				<Controller
					control={control}
					name="description"
					rules={rules.description}
					render={({ field: { onChange, value } }) => {
						return (
							<div className="mt-4">
								<div className="mb-3">
									<Typography
										title="Description"
										type={TypographyTypes.span}
										fontLeading="12/12"
									/>
								</div>
								<ReactQuill
									theme="snow"
									value={value}
									onChange={onChange}
									className="createdContent"
									placeholder={
										titleComponent === 'Create New Location'
											? 'Write your location details here'
											: 'Write your content here'
									}
								/>

								<div className="w-full flex justify-between items-center">
									<h1 className="text-xs leading-[9px] text-black-1/50 pt-2">
										{value ? value.length : 0}/
										{configGenaral.maxDescriptionLength}
									</h1>
									{value?.length > configGenaral.maxDescriptionLength && (
										<Message
											text={`Maximum ${configGenaral.maxDescriptionLength} characters exceeded`}
											type="error"
										/>
									)}
								</div>
							</div>
						)
					}}
				/>
			</div>
		</div>
	)
}
